"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LineRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var d3Shape = _interopRequireWildcard(require("d3-shape"));

function DefaultLine(props) {
  return _react.default.createElement("path", props.lineProps);
}

var LineRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(LineRenderable, _React$PureComponent);

  function LineRenderable() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LineRenderable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LineRenderable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lineGenerator", d3Shape.line().x(function (ii) {
      return ii.x;
    }).y(function (ii) {
      return ii.y;
    }).defined(function (ii) {
      return typeof ii.x === 'number' && typeof ii.y === 'number' && !isNaN(ii.x) && !isNaN(ii.y);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "areaGenerator", d3Shape.area().x(function (ii) {
      return ii.x;
    }).y1(function (ii) {
      return ii.y;
    }).y0(function () {
      return _this.props.height;
    }).defined(function (ii) {
      return typeof ii.x === 'number' && typeof ii.y === 'number' && !isNaN(ii.x) && !isNaN(ii.y);
    }));
    return _this;
  }

  (0, _createClass2.default)(LineRenderable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          Line = _this$props.line,
          curveSelector = _this$props.curveSelector,
          area = _this$props.area,
          scaledData = _this$props.scaledData,
          lineProps = _this$props.lineProps;
      var curveFunction = curveSelector ? curveSelector(d3Shape) : d3Shape.curveLinear;
      var pathGenerator = area ? this.areaGenerator.curve(curveFunction) : this.lineGenerator.curve(curveFunction);
      return _react.default.createElement("g", null, _react.default.createElement(Line, {
        pathGenerator: pathGenerator,
        data: data,
        scaledData: scaledData,
        lineProps: (0, _objectSpread2.default)({
          fill: area ? 'inherit' : 'none',
          stroke: area ? 'none' : 'inherit',
          d: pathGenerator(scaledData)
        }, lineProps)
      }));
    }
  }]);
  return LineRenderable;
}(_react.default.PureComponent);

exports.LineRenderable = LineRenderable;
(0, _defineProperty2.default)(LineRenderable, "defaultProps", {
  line: DefaultLine,
  area: false
});
(0, _defineProperty2.default)(LineRenderable, "propTypes", {
  height: _propTypes.default.number.isRequired,
  data: _propTypes.default.object,
  scaledData: _propTypes.default.arrayOf(_propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })).isRequired,
  line: _propTypes.default.func,
  lineProps: _propTypes.default.object,
  area: _propTypes.default.bool,
  curveSelector: _propTypes.default.func
});

var Line =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Line, _React$Component);

  function Line() {
    (0, _classCallCheck2.default)(this, Line);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(Line).apply(this, arguments));
  }

  (0, _createClass2.default)(Line, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(LineRenderable, this.props);
    }
  }]);
  return Line;
}(_react.default.Component);

(0, _defineProperty2.default)(Line, "chartType", 'canvas');
(0, _defineProperty2.default)(Line, "propTypes", {
  line: _propTypes.default.func,
  lineProps: _propTypes.default.object,
  area: _propTypes.default.bool,
  curveSelector: _propTypes.default.func
});
var _default = Line;
exports.default = _default;